import './CardPackSlot.css';

export function CardPackSlot() {
  return (
    <div className="card-pack-slot card-pack-slot--empty">
      <div className="card-pack-slot__container">
        <div className="card-pack-slot__image">
          <div className="card-pack-slot__empty-icon">📦</div>
        </div>
      </div>
    </div>
  );
}

